import { formatDate } from 'date';
import { formatCurrency, formatNumber, Stack, Typography } from 'ui';

import { useMatchedSiteMaterialItem } from '../../contexts/MatchedSiteMaterialItemContext';
import { DrawerSection } from '../DrawerSection/DrawerSection';

export const RecentTradingActivitySection = () => {
  const { siteMaterial, supplySignal } = useMatchedSiteMaterialItem();
  const supplySignalElements = [
    {
      label: 'Price',
      value: supplySignal?.price_per_tonne
        ? formatCurrency(supplySignal?.price_per_tonne, { currencyCode: supplySignal?.currency })
        : '-',
    },
    { label: 'Volume', value: supplySignal?.tonnes ? formatNumber(supplySignal?.tonnes, { style: 'ton' }) : '-' },
    {
      label: 'Last collection',
      value: supplySignal?.last_collection_date ? formatDate(supplySignal?.last_collection_date) : '-',
    },
  ];
  const lastOfferElements = [
    {
      label: 'Price',
      value: siteMaterial?.latest_offer?.price_per_tonne
        ? formatCurrency(siteMaterial?.latest_offer?.price_per_tonne.toString(), {
            currencyCode: siteMaterial?.latest_offer?.currency,
          })
        : '-',
    },
    {
      label: 'Volume',
      value:
        siteMaterial?.latest_offer?.tonnes_per_load && siteMaterial?.latest_offer?.number_of_loads
          ? formatNumber(siteMaterial?.latest_offer?.tonnes_per_load * siteMaterial?.latest_offer?.number_of_loads, {
              style: 'ton',
            })
          : '-',
    },
    {
      label: 'Offer date',
      value: siteMaterial?.latest_offer?.created_at ? formatDate(siteMaterial?.latest_offer?.created_at) : '-',
    },
  ];
  const latestDealElements = [
    {
      label: 'Price',
      value: siteMaterial?.latest_deal?.seller_price_per_tonne
        ? formatCurrency(siteMaterial?.latest_deal?.seller_price_per_tonne.toString(), {
            currencyCode: siteMaterial?.latest_deal?.currency,
          })
        : '-',
    },
    {
      label: 'Volume',
      value: siteMaterial?.latest_deal?.accepted_tonnage
        ? formatNumber(siteMaterial?.latest_deal?.accepted_tonnage, { style: 'ton' })
        : '-',
    },
    {
      label: 'Deal date',
      value: siteMaterial?.latest_deal?.created_at ? formatDate(siteMaterial?.latest_deal?.created_at) : '-',
    },
    {
      label: '% of LME',
      value: siteMaterial?.latest_deal?.seller_price_as_index_percentage
        ? formatNumber(siteMaterial?.latest_deal?.seller_price_as_index_percentage, { style: 'percent' })
        : '-',
    },
    {
      label: 'Deal margin(NTR)',
      value: siteMaterial?.latest_deal?.profitability_estimate.net_take_rate
        ? formatNumber(siteMaterial?.latest_deal?.profitability_estimate.net_take_rate, { style: 'percent' })
        : '-',
    },
  ];

  return (
    <Stack direction="column" gap={2} data-testid="recent-trading-activity-section">
      <Typography color="text.secondary">Recent trading</Typography>
      {supplySignal ? (
        <DrawerSection
          title="Live supply signal"
          name="live-signal"
          elements={supplySignalElements}
          data-testid={'live-supply-signal'}
        />
      ) : null}
      {siteMaterial?.latest_deal ? (
        <DrawerSection
          title="Latest seller deal"
          name="latest-deal"
          elements={latestDealElements}
          data-testid={'latest-deal'}
        />
      ) : null}
      {siteMaterial?.latest_offer ? (
        <DrawerSection title="Last offer" name="last-offer" elements={lastOfferElements} data-testid={'last-offer'} />
      ) : null}
    </Stack>
  );
};
